module.exports = __webpack_public_path__ + "assets/ns-icon-query-light.94f81102.svg";